import MuiLoadingButton, { LoadingButtonProps as MuiLoadingButtonProps } from '@mui/lab/LoadingButton';

export type LoadingButtonProps = MuiLoadingButtonProps & {
  rounded?: boolean;
};
export function LoadingButton({ rounded = true, sx, ...props }: LoadingButtonProps) {
  return <MuiLoadingButton sx={{ borderRadius: rounded ? '100px' : undefined, ...sx }} {...props} />;
}
